/* eslint semi:0 */
import { makeSafeFn, } from 'utils/fn'

let cooladataScriptConfig = {
  name: 'cooladata',
  src: '//cdn.cooladata.com/tracking/cooladata-2.1.9.min.js',
  beforeLoad: makeSafeFn(function unsafeInitCooladata(){
    /* eslint-disable */
    let a,e,g;window.cooladata=a=[];a._i=[];a.init=function(b,c,f){function d(a,b){var c=b.split(".");2==c.length&&(a=a[c[0]],b=c[1]);a[b]=function() {a.push([b].concat(Array.prototype.slice.call(arguments,0)))}}var h=a;"undefined"!==typeof f?h=a[f]=[]:f="cooladata";g=["trackEvent","trackEventLater","trackPageload","flush","setConfig"];for(e=0;e<g.length;e++)d(h,g[e]);a._i.push([b,c,f])};a.__SV=1.2;
    /* eslint-enable */
  }),
}

export default cooladataScriptConfig


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/cooladataScript.js